module.exports = __webpack_public_path__ + "img/premium2.b1aec7a5.jpg";